import "./base.css";

import NavBar from "./components/NavBar";
import { newElement } from "./Dom";
import Router, { type Route } from "./Router";
import AboutView from "./views/AboutView";
import HomeView from "./views/HomeView";
import NotFoundView from "./views/NotFoundView";

const app = document.getElementById("app");
if (app === null) {
    throw new Error("fann ikkje #app i dokumentet");
}

const routes: Route[] = [
    { path: "/", label: "Home", view: () => new HomeView() },
    { path: "/about", label: "About", view: () => new AboutView() },
    { path: "/404", view: () => new NotFoundView() },
];

const navBar = new NavBar().addRoutes(routes);
const outlet = newElement("div", { id: "outlet" });

app.replaceChildren(navBar, outlet);

new Router(outlet, routes).init();
